import { render, staticRenderFns } from "./AIAgent.EmptyChat.vue?vue&type=template&id=2ba608f7&lang=pug"
import script from "./AIAgent.EmptyChat.vue?vue&type=script&lang=js"
export * from "./AIAgent.EmptyChat.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.EmptyChat.vue?vue&type=style&index=0&id=2ba608f7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports